export default function Setup2FAPage() {
  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-900">Configura 2FA</h1>
      <p className="mt-2 text-gray-600">
        Configura l'autenticazione a due fattori per maggiore sicurezza
      </p>
      <div className="mt-8 card card-body">
        <p className="text-gray-500">Configurazione 2FA - da implementare</p>
      </div>
    </div>
  )
}
